export default "__VITE_ASSET__b956d0b9__"